import StorageOptionFull from './components/StorageOptionFull';
import { Option } from 'owa-options-core';
import * as React from 'react';
import { getUserConfiguration } from 'owa-session-store';

let StorageOption: Option = {
    key: 'mailboxStorage',
    titleStringKey: 'optionTitle_storage',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_storage',
    fullOptionFormSettings: {
        render: () => <StorageOptionFull isPremium={false} />,
        isDirty: () => false,
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: () => true,
    },
    isHidden: () => getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
};

export default StorageOption;
